module.exports = __webpack_public_path__ + "img/project1.0231a27b.jpg";